// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import recruit from './routes/recruit';
import album from './routes/album';
import environment from './routes/environment';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  recruit,
  environment,
  album,
});

// Load Events
window.addEventListener('DOMContentLoaded', () => {
  routes.loadEvents();
})



// WEBPACK FOOTER //
// ./scripts/main.js